export const FETCH_DISCUSSION_UNREADS_REQUEST = "FETCH_DISCUSSION_UNREADS_REQUEST";
export const FETCH_DISCUSSION_UNREADS_SUCCESS = "FETCH_DISCUSSION_UNREADS_SUCCESS";
export const MARK_DISCUSSION_SEEN_SUCCESS = "MARK_DISCUSSION_SEEN_SUCCESS";
export const BOARD_UNREAD_UPDATED = "BOARD_UNREAD_UPDATED";
